/**
 * 사전 승인 결제 1회 최대한도
 * BE에서 받는 값이지만 BE에서 못받은 경우를 대비하여 2026.01.21 배포 버전 기준으로
 * default 값을 상수로 정의함
 */
export const DEFAULT_PRE_APPROVAL_PAYMENT_LIMIT = 300000
